// Builds crisp home-screen / tab icons from the uploaded brand logo.
//
// Problem it solves: a transparent brand logo used directly as the app icon
// composites to a near-black square on many launchers (and on the iOS home
// screen). We instead paint the logo centred on a solid light background with
// safe padding, then wire the result into the favicon, apple-touch-icon and a
// dynamically generated web manifest so the *installed* icon looks right too.

const BG = '#FFFFFF';
let lastLogo = null;

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement('link'); el.rel = rel; document.head.appendChild(el); }
  el.href = href;
}

function drawIcon(img, size, padRatio) {
  const canvas = document.createElement('canvas');
  canvas.width = size; canvas.height = size;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = BG;
  ctx.fillRect(0, 0, size, size);
  const pad = Math.round(size * padRatio);
  const box = size - pad * 2;
  const ratio = Math.min(box / img.width, box / img.height);
  const w = img.width * ratio;
  const h = img.height * ratio;
  ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
  return canvas.toDataURL('image/png');
}

// Apply the uploaded logo as the app icon. `logo` is expected to be a data URL
// (that is how uploads are stored) so the canvas is never tainted.
export function applyAppIcon(logo) {
  if (typeof document === 'undefined') return;
  if (!logo) return;
  if (logo === lastLogo) return;
  lastLogo = logo;

  // Immediate fallback: use the raw logo for the tab icon straight away.
  setLink('icon', logo);
  setLink('apple-touch-icon', logo);

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => {
    try {
      // 12% padding keeps the logo inside the icon's safe area.
      const i192 = drawIcon(img, 192, 0.12);
      setLink('icon', i192);
      setLink('apple-touch-icon', i192);
    } catch (e) {
      // Canvas failed (e.g. tainted / invalid image) — the raw-logo fallback above stays.
    }
  };
  img.onerror = () => { /* keep raw fallback */ };
  img.src = logo;
}
